<ngb-alert *ngIf="isErrorVisible" type="danger" [dismissible]="false">
  <p *ngFor="let errorKey of form.errors | devappKeys">
    {{ form.getError(errorKey) | devappFormErrorMessage: errorKey : 'Form' : errorDescriptors }}
  </p>
</ngb-alert>
